module.exports = __webpack_public_path__ + "media/images/copy-36c3eebba99a45579196f979d86b4530.svg";